module.exports = __webpack_public_path__ + "assets/img/topbannerys.8dae3be4.png";